module.exports = "/images/vendor/flag-icon-css/flags/4x3/ao.svg?8b6f2ec29629876f9c00839932ded057";